import './IongChart1.scss';
import React from "react";
import {
  ComposedChart,
  Line,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

// ✅ 커스텀 툴팁 (Line만 필터링)  툴팁에 같은 게 두 개가 나와서 커스텀을 이용해야 한다.
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const filtered = payload.filter(p => p.dataKey === 'value');

    return (
      <div style={{ background: '#fff', border: '1px solid #ccc', padding: 10 }}>
        <strong>{label}</strong>
        {filtered.map((entry, idx) => (
          <p key={idx} style={{ color: entry.color }}>
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

// ✅ 재사용 차트 컴포넌트
const IongChart1 = ({ chartTitle = "차트 제목", data = [], color = "#FF0000", maxValue }) => {
  // ✅ 내부에서 area-only 데이터 자동 생성 (value 복사)
  const enhancedData = data.map(item => ({
    ...item,
    'area-only': item.value
  }));

  return (
    <div className="IongChart1">
      <h2 className="chart-title" style={{ color: color }}>
        {chartTitle}
      </h2>
      <div className="chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={enhancedData} className="composed-chart"
            margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis
              // domain={[0, 'dataMax + 10']}
              domain={[0, maxValue || 'auto']}
              tickFormatter={(value) => value === 0 ? '' : value}
            />
            <Tooltip content={<CustomTooltip />} />

            {/* ✅ 배경 채움용 Area (툴팁 제외) */}
            <Area
              type="linear"
              dataKey="area-only"
              stroke="none"
              fill={color}
              fillOpacity={0.3}
            />

            {/* ✅ 실제 데이터 표시용 Line */}
            <Line
              type="linear"
              dataKey="value"
              name={chartTitle}
              stroke={color}
              strokeWidth={3}
              dot={{ r: 5 }}
              activeDot={{ r: 7 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default IongChart1;
